module.exports = __webpack_public_path__ + "static/media/district53.7fb22ee0.png";